import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export const TOOLTIP_MAX_NUM_CHARACTERS = 250;
export const MENTION_NODE_ICON_SIZE_PX = 18;
export const MENTION_NODE_CHIP_CLASS_NAME = 'rounded-md px-1 py-two transition-colors group-hover/mention:bg-subtle group-focus-visible/mention:bg-subtle';
export const MENTION_NODE_CHIP_TEXT_CLASS_NAME = 'leading-[1.3]';
export const MENTION_NODE_CHIP_ICON_CLASS_NAME = 'mr-1 size-[18px] self-center text-primary';
export const MENTION_NODE_CHIP_EMOJI_CLASS_NAME = 'mr-1 text-[0.80rem]';
const MENTION_NODE_VARIANTS = new Set([
    'tab',
    'space',
    'shortcut',
    'sources',
    'search-mode',
    'skills',
    'slash-command',
    'plugin',
    'device',
    'user',
]);
function isSlashPrefixedMentionVariant(variant) {
    switch (variant) {
        case 'skills':
        case 'plugin':
            return true;
        case 'tab':
        case 'space':
        case 'shortcut':
        case 'sources':
        case 'search-mode':
        case 'slash-command':
        case 'device':
        case 'user':
        case undefined:
            return false;
        default:
            return assertUnreachableValue(variant);
    }
}
export function getMentionNodeDisplayText({ text, localizedName, mentionVariant, prefixWithSlash, }) {
    const displayText = localizedName || text;
    return isSlashPrefixedMentionVariant(mentionVariant) &&
        prefixWithSlash !== false &&
        !displayText.startsWith('/')
        ? `/${displayText}`
        : displayText;
}
export function getDefaultMentionIcon(variant) {
    return variant === 'slash-command' ? { type: 'icon', icon: $icon('slash') } : undefined;
}
export function isMentionNodeVariant(variant) {
    return MENTION_NODE_VARIANTS.has(variant);
}
export function serializeMentionNodeProps(props) {
    return {
        ...props,
        icon: serializeMentionIcon(props.icon),
    };
}
export function serializeMentionIcon(icon) {
    if (!icon) {
        return undefined;
    }
    switch (icon.type) {
        case 'emoji':
            return icon;
        case 'image':
            return icon;
        case 'icon':
            return typeof icon.icon === 'string' ? { type: 'icon', icon: icon.icon } : undefined;
        case 'source':
            return icon;
    }
}
export function parseSerializedMentionIcon(serializedIcon) {
    if (!serializedIcon) {
        return undefined;
    }
    try {
        return deserializeMentionIcon(JSON.parse(serializedIcon));
    }
    catch {
        return undefined;
    }
}
function deserializeMentionIcon(icon) {
    if (!isRecord(icon)) {
        return undefined;
    }
    if (icon.type === 'emoji' && typeof icon.char === 'string') {
        return { type: 'emoji', char: icon.char };
    }
    if (icon.type === 'image' && typeof icon.url === 'string') {
        return { type: 'image', url: icon.url };
    }
    if (icon.type === 'icon' && typeof icon.icon === 'string') {
        return {
            type: 'icon',
            icon: icon.icon,
        };
    }
    if (icon.type === 'source' && typeof icon.sourceId === 'string') {
        return { type: 'source', sourceId: icon.sourceId };
    }
    return undefined;
}
function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
//# sourceMappingURL=MentionNodeShared.js.map